export default "__VITE_ASSET__5f4d0566__"